module.exports = __webpack_public_path__ + "img/device-desktop.259f8ecf.svg";